<template>
  <div class="data-panel">
    <h3 class="data-title">Pagamento e Contrato</h3>
    <div v-if="loading" style="color:#6b7280;font-size:14px;">Carregando...</div>
    <div v-else class="data-settings">
      <div class="data-field">
        <label>Plano</label>
        <select v-model="payPlan" class="data-select">
          <option value="basico">Básico</option>
          <option value="normal">Normal</option>
          <option value="completo">Completo</option>
        </select>
      </div>
      <div class="data-field">
        <label>Máximo de usuários</label>
        <input v-model.number="payMaxUsers" type="number" min="1" />
      </div>
      <div class="data-field">
        <label>Valor do contrato (R$)</label>
        <input v-model.number="payContractValue" type="number" min="0" step="0.01" />
      </div>
      <div class="data-field">
        <label>Dia do vencimento (1–28)</label>
        <input v-model.number="payDay" type="number" min="1" max="28" />
      </div>
      <div class="data-field">
        <label>Status do pagamento</label>
        <select v-model="payStatus" class="data-select">
          <option value="em-dia">Em dia</option>
          <option value="atrasado">Atrasado</option>
          <option value="suspenso">Suspenso</option>
        </select>
      </div>
      <div class="data-field">
        <label>Último pagamento em</label>
        <input v-model="payLastAt" type="date" />
      </div>
      <p v-if="payError" class="data-error">{{ payError }}</p>
      <p v-if="paySuccess" class="data-success">{{ paySuccess }}</p>
      <button class="btn-admin-primary" type="button" :disabled="paySaving" @click="savePayment">
        {{ paySaving ? 'Salvando...' : 'Salvar pagamento' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, inject, onMounted } from 'vue'
import { masterFetch } from '@/store/masterSession'

export default {
  name: 'AdminSysPaymentTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const loading = ref(false)
    const payPlan = ref('basico')
    const payMaxUsers = ref(10)
    const payContractValue = ref(0)
    const payDay = ref(1)
    const payStatus = ref('em-dia')
    const payLastAt = ref('')
    const paySaving = ref(false)
    const payError = ref('')
    const paySuccess = ref('')

    const loadPayment = async () => {
      if (!detail?.value) return
      loading.value = true
      try {
        const p = await masterFetch<{ contractValue: number; paymentDay: number; paymentStatus: string; lastPaymentAt: string; plan: string; maxUsers: number }>(`/master/systems/${detail.value.systemId}/payment`)
        payPlan.value = p.plan || 'basico'
        payMaxUsers.value = p.maxUsers || 10
        payContractValue.value = p.contractValue || 0
        payDay.value = p.paymentDay || 1
        payStatus.value = p.paymentStatus || 'em-dia'
        payLastAt.value = p.lastPaymentAt ? p.lastPaymentAt.slice(0, 10) : ''
      } catch { /* ignore */ } finally {
        loading.value = false
      }
    }

    onMounted(loadPayment)

    const savePayment = async () => {
      payError.value = ''
      paySuccess.value = ''
      if (!detail?.value) return
      paySaving.value = true
      try {
        await masterFetch(`/master/systems/${detail.value.systemId}/payment`, {
          method: 'PUT',
          body: JSON.stringify({
            contractValue: payContractValue.value,
            paymentDay: payDay.value,
            paymentStatus: payStatus.value,
            lastPaymentAt: payLastAt.value,
          })
        })
        await masterFetch(`/master/systems/${detail.value.systemId}/plan`, {
          method: 'PUT',
          body: JSON.stringify({ plan: payPlan.value, maxUsers: payMaxUsers.value })
        })
        paySuccess.value = 'Pagamento salvo com sucesso.'
      } catch (err: unknown) {
        payError.value = err instanceof Error ? err.message : 'Erro ao salvar.'
      } finally {
        paySaving.value = false
      }
    }

    return { loading, payPlan, payMaxUsers, payContractValue, payDay, payStatus, payLastAt, paySaving, payError, paySuccess, savePayment }
  }
}
</script>

<style lang="scss">
/* Shared styles — defined in AdminSysDataTab */
</style>
